export var axisType;
(function (axisType) {
    axisType["VALUE"] = "value";
    axisType["LOG"] = "log";
    axisType["CATEGORY"] = "category";
    axisType["TIME"] = "time";
})(axisType || (axisType = {}));
